<template>
  <div>
    <draggable v-model="content" handle=".grip">
      <component :is="opr.call.split('.')[1]" v-for="(opr,i) in content" :key="opr._id"
        :options="opr.arguments" @input="opr.arguments = $event"
        :iconList="iconList" @remove="removeItem(i)"
      >
      </component>
    </draggable>    
    <b-dropdown size="lg"  variant="link" no-caret>
      <template v-slot:button-content>
        <font-awesome-icon icon="plus-square" class="icon fa-2x" />
      </template>
      <b-dropdown-item @click="addItem('remark')">セリフ</b-dropdown-item>
      <b-dropdown-item @click="addItem('text-note')">テキスト</b-dropdown-item>
      <b-dropdown-item @click="addItem('set-bg')">背景セット</b-dropdown-item>
      <template v-if="$store.getters.admin">
        <b-dropdown-item @click="addItem('black-out')">背景OFF</b-dropdown-item>
        <b-dropdown-item @click="addItem('clear')">クリア</b-dropdown-item>
        <b-dropdown-item @click="addItem('introduction')">紹介</b-dropdown-item>
        <b-dropdown-item @click="addItem('fade-in')">フェードイン</b-dropdown-item>
        <b-dropdown-item @click="addItem('fade-out')">フェードアウト</b-dropdown-item>
        <b-dropdown-item @click="addItem('message-open')">テキスト開始</b-dropdown-item>
        <b-dropdown-item @click="addItem('message-close')">テキスト終了</b-dropdown-item>
      </template>
    </b-dropdown>
    <span :class="{ max: content.length>=max }" class="m-2">
      {{ content.length }} / {{ max }}
    </span>
    <b-button v-if="preview" class="m-2"
      @click="$emit('preview', content)"
    >
      プレビュー
    </b-button>
  </div>
</template>

<script>
import parts from './mixin-parts'
import draggable from 'vuedraggable'
import _ from 'lodash'
export default {
  name: 'code-editor',
  props: {
    value: Array,
    iconList: Array,
    max: { type:Number, default:5 },
    preview: { type:Boolean, default:true }
  },
  components: {
    draggable
  },
  computed: {
  },
  data () {
    return {
      content: this.format(this.value),
      open: false
    }
  },
  methods: {
    format (value) {
      value.forEach(v => v._id = _.uniqueId())
      return value
    },
    addItem (item) {
      if(this.content.length >= this.max){ return }
      this.content.push({
        call: `story-note.${item}`,
        arguments: {},
        _id: _.uniqueId()
      })
    },
    removeItem (key) {
      this.content.splice(key, 1)
    }
  },
  watch: {
    content (val) {
      this.$emit('input', val)
    },
    value (val) {
      this.content = this.format(val)
    }
  },
  mixins: [
    parts
  ]
}
</script>

<style lang="scss" scoped>
.max {
  color: #F00;
}
</style>
